import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import {
  Heading,
  FilterSelect,
  SkeletonLoader,
  SpinnerLoader
} from '@warrenbrasil/nebraska-web';
import { VerticalListDisplay } from './components/VerticalListDisplay';

import {
  PortfolioChartFilter,
  PortfolioChartSummary
} from '@/modules/wealth/services/portfolio';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';

interface Props {
  isLoading: boolean;
  hasError: boolean;
  portfolioChartSummary: PortfolioChartSummary | null;
  periodFilters: PortfolioChartFilter[];
  benchmarkFilters: PortfolioChartFilter[];
  profitLabel?: string;
  returnLabel?: string;
}
interface Emits {
  (e: 'on-period-filter-change', value: string): void;
  (e: 'on-benchmark-filter-change', value: string): void;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'PerformanceHeader',
  props: {
    isLoading: { type: Boolean },
    hasError: { type: Boolean },
    portfolioChartSummary: null,
    periodFilters: null,
    benchmarkFilters: null,
    profitLabel: { default: 'Rendimento' },
    returnLabel: { default: 'Rentabilidade' }
  },
  emits: ["on-period-filter-change", "on-benchmark-filter-change"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'on-period-filter-change', value: string): void;
  (e: 'on-benchmark-filter-change', value: string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { isLoading: boolean, hasError: boolean, portfolioChartSummary: PortfolioChartSummary | null, periodFilters: PortfolioChartFilter[], benchmarkFilters: PortfolioChartFilter[], profitLabel: string, returnLabel: string };





const benchmarkReturn = computed(() => {
  return props.portfolioChartSummary?.benchmarkReturn;
});

const portfolioProfitValue = computed(() => {
  return props.portfolioChartSummary?.profitValue;
});

const portfolioReturn = computed(() => {
  return props.portfolioChartSummary?.return;
});

const portfolioReturnComparedToBenchmark = computed(() => {
  return props.portfolioChartSummary?.returnComparedToBenchmark;
});

const activePeriodFilter = computed(() => {
  const filter = props.periodFilters?.find(filter => filter.active);
  return {
    value: filter?.key || '',
    label: filter?.label || '-'
  };
});

const activeBenchmarkFilter = computed(() => {
  const filter = props.benchmarkFilters?.find(filter => filter.active);
  return {
    value: filter?.key || '',
    label: filter?.summaryLabel || '-',
    comparator: filter?.label || '-'
  };
});

const hasFilter = computed(() => {
  return props.benchmarkFilters?.length > 0 || props.periodFilters?.length > 0;
});

const returnComparedToBenchmarkLabel = computed(() => {
  if (activeBenchmarkFilter.value.comparator.includes('CDI')) {
    return `% ${activeBenchmarkFilter.value.label === 'Meta' ? 'da' : 'do'} ${
      activeBenchmarkFilter.value.label
    }`;
  }

  return `± ${activeBenchmarkFilter.value.label}`;
});

const emitPeriodFilterChange = (value: string) => {
  emit('on-period-filter-change', value);
};

const emitBenchmarkFilterChange = (value: string) => {
  emit('on-benchmark-filter-change', value);
};

return { __sfc: true,props, emit, benchmarkReturn, portfolioProfitValue, portfolioReturn, portfolioReturnComparedToBenchmark, activePeriodFilter, activeBenchmarkFilter, hasFilter, returnComparedToBenchmarkLabel, emitPeriodFilterChange, emitBenchmarkFilterChange, Heading, FilterSelect, SkeletonLoader, SpinnerLoader, VerticalListDisplay, NebraskaColors }
}

})